import { stripHTML } from '../utils'
import { z } from 'zod'

export const descriptionSchema = z
  .object({
    lang: z.string(),
    plainText: z
      .string()
      .transform((description) => stripHTML(description, true)),
    descriptionId: z.union([
      z.string(),
      z.number().int().nonnegative().transform(String),
    ]),
    category: z.string().optional().nullable().default(null),
    loadSource: z.string().optional(),
    dataFormat: z.string().optional(),
    sequence: z.number(),
  })
  .describe('KTMine Patent Description Item Schema')

export type Description = z.infer<typeof descriptionSchema>

export const apiPatentDescriptionSchema = z.object({
  items: z.array(
    z.object({
      descriptions: z.array(descriptionSchema).optional(),
    })
  ),
})

export type ApiPatentDescription = z.infer<typeof apiPatentDescriptionSchema>

export const patentDescriptionSchema = apiPatentDescriptionSchema.transform(
  (patentDescription) => {
    return patentDescription.items[0]?.descriptions ?? []
  }
)
